import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function normalizeComponentName(name: string): string {
  return name.trim().replace(/\s+/g, ' ').toLowerCase();
}

export function sortByNameSv<T extends { name: string }>(items: T[]): T[] {
  return [...items].sort((a, b) => a.name.localeCompare(b.name, 'sv-SE', { sensitivity: 'base' }));
}
